import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, Trophy, BarChart3, Menu as MenuIcon, Sparkles, LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import MobileMenuSheet from "./MobileMenuSheet";

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  const isActive = (path: string) => location.pathname === path;

  const handleHome = () => navigate(user ? "/dashboard" : "/");

  const NavItem = ({
    icon: Icon,
    label,
    onClick,
    active,
    ariaLabel,
  }: {
    icon: React.ElementType;
    label: string;
    onClick: () => void;
    active?: boolean;
    ariaLabel: string;
  }) => (
    <button
      onClick={onClick}
      aria-label={ariaLabel}
      className={`flex flex-col items-center justify-center gap-0.5 flex-1 h-full transition-colors active:scale-95 ${
        active ? "text-primary" : "text-muted-foreground"
      }`}
    >
      <Icon className="w-5 h-5" />
      <span className="text-[10px] font-medium">{label}</span>
    </button>
  );

  return (
    <>
      <nav
        className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-t border-border h-16 flex items-center px-1 pb-[env(safe-area-inset-bottom)]"
        aria-label="Navegação inferior"
      >
        <NavItem
          icon={Home}
          label="Início"
          onClick={handleHome}
          active={isActive("/") || isActive("/dashboard")}
          ariaLabel="Página inicial"
        />
        <NavItem
          icon={Trophy}
          label="Resultados"
          onClick={() => navigate("/resultados-bicho")}
          active={isActive("/resultados-bicho")}
          ariaLabel="Resultados do Bicho"
        />

        {/* Botão central — GERAR IA (logado) ou ENTRAR (deslogado) */}
        <div className="flex-1 flex justify-center">
          {user ? (
            <button
              onClick={() => navigate("/gerar-jogos")}
              aria-label="Gerar Jogos com IA"
              className="relative -translate-y-5 flex flex-col items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-yellow-400 via-yellow-500 to-orange-600 shadow-lg shadow-orange-500/40 ring-4 ring-background active:scale-95 transition-transform"
            >
              <Sparkles className="w-6 h-6 text-white" strokeWidth={2.5} />
              <span className="text-[9px] font-bold text-white mt-0.5">
                GERAR IA
              </span>
            </button>
          ) : (
            <button
              onClick={() => navigate("/login")}
              aria-label="Entrar na conta"
              className="relative -translate-y-5 flex flex-col items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-yellow-400 via-yellow-500 to-orange-600 shadow-lg shadow-orange-500/40 ring-4 ring-background active:scale-95 transition-transform"
            >
              <LogIn className="w-6 h-6 text-white" strokeWidth={2.5} />
              <span className="text-[9px] font-bold text-white mt-0.5">
                ENTRAR
              </span>
            </button>
          )}
        </div>

        <NavItem
          icon={BarChart3}
          label="Estatísticas"
          onClick={() => navigate("/estatisticas")}
          active={isActive("/estatisticas")}
          ariaLabel="Estatísticas"
        />
        <NavItem
          icon={MenuIcon}
          label="Menu"
          onClick={() => setMenuOpen(true)}
          active={menuOpen}
          ariaLabel="Abrir menu de ferramentas"
        />
      </nav>

      <MobileMenuSheet open={menuOpen} onOpenChange={setMenuOpen} />
    </>
  );
};

export default MobileBottomNav;
